import type { ReactNode } from 'react';
import * as Sentry from '@sentry/react';

interface ErrorBoundaryProps {
  children: ReactNode;
  fallback: JSX.Element;
}

export default function ErrorBoundary({
  children,
  fallback,
}: Readonly<ErrorBoundaryProps>) {
  return (
    <Sentry.ErrorBoundary fallback={fallback}>{children}</Sentry.ErrorBoundary>
  );
}
